import { Plus, Clock, Trash2 } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const Sidebar = () => {
  const {
    theme,
    conversations,
    activeConversationId,
    setActiveConversationId,
    handleNewChat,
    deleteConversation,
    isSidebarOpen,
    setIsSidebarOpen
  } = useAppContext();

  return (
    <>
      <div className={`flex flex-col p-4 sidebar-container transition-transform duration-300 h-full ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } ${theme === 'dark' ? 'bg-gray-900 border-r border-gray-800' : 'bg-gray-50 border-r border-gray-200'}`}>
        
        <button
          onClick={handleNewChat}
          className={`flex items-center gap-2 w-full p-3 rounded-lg mb-6 transition-colors shadow-sm font-medium
            ${theme === 'dark' 
              ? 'bg-blue-600 hover:bg-blue-700 text-white' 
              : 'bg-blue-500 hover:bg-blue-600 text-white'}`}
        >
          <Plus size={20} />
          <span>New Chat</span>
        </button>

        <div className="flex-grow overflow-y-auto">
          <div className="mb-2">
            
            <div className="flex items-center gap-2 mb-4">
              <Clock size={18} className="text-blue-400" />
              <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
                Recent Chats
              </h2>
            </div>

            <div className="flex flex-col space-y-1">
              {Object.entries(conversations).reverse().map(([convoId, convo]) => (
                <div 
                  key={convoId} 
                  className={`flex items-center gap-2 p-3 rounded-lg cursor-pointer transition-colors ${
                    activeConversationId === convoId 
                      ? (theme === 'dark' ? 'bg-gray-800 border-l-4 border-blue-500' : 'bg-gray-200 border-l-4 border-blue-500') 
                      : (theme === 'dark' ? 'hover:bg-gray-800 border-l-4 border-transparent' : 'hover:bg-gray-200 border-l-4 border-transparent')
                  }`} 
                  onClick={() => {
                    setActiveConversationId(convoId);
                    if (window.innerWidth < 768) setIsSidebarOpen(false); 
                  }}
                >
                  <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'} truncate text-sm font-medium flex-1`}>
                    {convo.title}
                  </p>
                  {(convo.persisted || convo.messages.length > 0) && (
                    <button
                      type="button"
                      aria-label={`Delete ${convo.title}`}
                      onClick={event => {
                        event.stopPropagation();
                        deleteConversation(convoId);
                      }}
                      className={`p-1 rounded transition-colors ${
                        theme === 'dark'
                          ? 'text-gray-400 hover:text-red-400 hover:bg-gray-700'
                          : 'text-gray-500 hover:text-red-500 hover:bg-gray-300'
                      }`}
                    >
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;